import axiosClient from "../api/axiosClient";

// How much chat history a @Room shows its members (ChatRoom.
// ChatHistoryVisibilityMode/Value). Maps to ChatController's
// "Room/{Id}/ChatHistoryVisibilitySetting" endpoint — only takes effect for
// @Room chats (Event.EventType === "ARoom"); ordinary Event chats instead cut
// off entirely once the Open-Door phase ends, and personal 1:1 chats are
// never limited.
export const CHAT_HISTORY_VISIBILITY_MODE = {
  MessageCount: 0,
  TimePeriod: 1,
  FullHistory: 2,
};

export const setChatHistoryVisibility = (chatRoomId, mode, value) =>
  axiosClient.post(`/Chat/Room/${chatRoomId}/ChatHistoryVisibilitySetting`, {
    Mode: mode,
    Value: mode === CHAT_HISTORY_VISIBILITY_MODE.FullHistory ? 0 : value,
  });
